<template>
  <div class="top-right-btn">
    <el-row>
      <el-tooltip v-if="search" content="显示/隐藏搜索" placement="top">
        <el-button circle icon="Search" @click="toggleSearch" />
      </el-tooltip>
      <el-tooltip content="刷新" placement="top">
        <el-button circle icon="Refresh" @click="refresh" />
      </el-tooltip>
    </el-row>
  </div>
</template>

<script setup lang="ts">
/**
 * RuoYi 列表页右侧工具栏（显示/隐藏搜索、刷新）
 * 原 RuoYi RightToolbar，清理后在此恢复最小实现
 */
defineOptions({
  name: 'RightToolbar',
});

const props = withDefaults(
  defineProps<{
    showSearch?: boolean;
    /** 是否显示「搜索区切换」按钮 */
    search?: boolean;
  }>(),
  {
    showSearch: true,
    search: true,
  },
);

const emit = defineEmits<{
  'update:showSearch': [value: boolean];
  queryTable: [];
}>();

function toggleSearch() {
  emit('update:showSearch', !props.showSearch);
}

function refresh() {
  emit('queryTable');
}
</script>

<style scoped lang="scss">
.top-right-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
}
</style>
